var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { cloneDeep, merge, omit } from "lodash";
import { injectIntl } from "@irati/utils/lang";
import authentication from "@irati/auth";
import Hr from "@irati/ui/src/Layout/Hr";
import teamService from "@irati/identity/services/teams";
import TeamName from "@irati-web/fields/team/PublicName";
import Form from "@irati/ui/src/Form";
import GenericModal from "@irati/ui/src/GenericModal";
var EditTeamNamePopUp = /** @class */ (function (_super) {
    __extends(EditTeamNamePopUp, _super);
    function EditTeamNamePopUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            name: _this.props.team.public_name,
            submit: null
        };
        _this.handleChange = function (name) {
            _this.setState({
                name: name,
                submit: null
            });
        };
        _this.handleHide = function () {
            _this.setState({
                name: _this.props.team.public_name
            });
            _this.props.onHide();
        };
        _this.handleSave = function () {
            var team = _this.props.team;
            var data = merge(omit(cloneDeep(team), "users"), { public_name: _this.state.name.trim() });
            var submit = teamService.update(authentication.userTenant().uuid, data, team.Etag).then(function () { return _this.props.onSuccess(); });
            _this.setState({
                submit: submit
            });
        };
        return _this;
    }
    EditTeamNamePopUp.prototype.render = function () {
        var _a = this.props, show = _a.show, team = _a.team;
        var _b = this.state, submit = _b.submit, name = _b.name;
        return (React.createElement("div", null,
            React.createElement(GenericModal, { title: team.public_name, show: show, onHide: this.handleHide, onConfirm: this.handleSave, dismissButtonText: "platform.components.areYouSurePopUp.button.cancel", proceedButtonText: "admin.components.editTeamPopUp.validationButton.save", load: submit },
                React.createElement(Hr, { solid: true }),
                React.createElement(Form, null,
                    React.createElement(TeamName, { onChange: this.handleChange, value: name })))));
    };
    return EditTeamNamePopUp;
}(Component));
export default injectIntl(EditTeamNamePopUp, { withRef: true });
